import Slider from 'react-slick';
import './HomePageCss/FirstSection.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img1 from '../../Assets/rbhome.jpg';
import img2 from '../../Assets/bg2.jpg';
import img3 from '../../Assets/bg3.jpg';
import img4 from '../../Assets/slider-02.jpg';
import img5 from '../../Assets/slider-03.jpg';
import img6 from '../../Assets/RB-banner1.jpg';
import img7 from '../../Assets/RB-banner-web1.webp';
import img8 from '../../Assets/RB-banner-web2.webp';
import img9 from '../../Assets/RB-banner-web3.webp';
// import img10 from '../../AssetsRB-banner-web4.webp';
// import img11 from '../../Assets/RB-banner-web5.jpg';

// import mobileImg1 from '../../Assets/MobileBanner/mobileBanner01.jpg'

import useIsMobile from '../../Hooks/IsmobileHook';

const images = [img7, img8, img9,];
// const mobileBannerImage = [mobileImg1];

const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
};

const FirstSection = () => {
    const isMobile = useIsMobile();

    return (
<div className="hero-slider-container" style={{ position: "relative", overflow: "hidden" }}>
  {/* Slider Images */}
  <Slider {...sliderSettings}>
    {images.map((image, index) => (
      <div key={index} className="hero-slide">
        <div className="slider-image">
          <div className="hero-image">
            <img src={image} alt={`Slide ${index + 1}`} />
          </div>
        </div>
      </div>
    ))}
  </Slider>

  <div className="hero-section-degins">
    <div className="lefdeginstdiv"></div>
    <div className="rightdegindiv"></div>
  </div>

  <div className="hero-fixed-overlay">
    <div className="scrolling-text-wrapper">
      <div className="scrolling-text-inner"></div>
    </div>
  </div>
</div>

    );
};

export default FirstSection;
// import Slider from "react-slick";
// import "./HomePageCss/FirstSection.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import useIsMobile from "../../Hooks/IsmobileHook";
// import { getBanner } from "../../api/api";
// import { useEffect, useState } from "react";

// const sliderSettings = {
//   dots: true,
//   infinite: true,
//   autoplay: true,
//   speed: 1200,
//   autoplaySpeed: 3000,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
// };

// const FirstSection = () => {
//   const isMobile = useIsMobile();
//   const [bannerList, setBannerList] = useState([]);

//   useEffect(() => {
//     const fetchBanner = async () => {
//       try {
//         const response = await getBanner({ search_key: "" });

//         // IMPORTANT FIX — encode URL to handle spaces
//         const webBanners = response?.data?.web?.map((b) => ({
//           ...b,
//           BannerUrl: encodeURI(b.BannerUrl),
//         }));

//         setBannerList(webBanners || []);
//       } catch (error) {
//         console.error("Error fetching banners:", error);
//       }
//     };

//     fetchBanner();
//   }, []);

//   return (
//     <div
//       className="hero-slider-container"
//       style={{ position: "relative", overflow: "hidden" }}
      

//     >
//       <Slider {...sliderSettings}>
//         {bannerList.map((item, index) => (
//           <div key={index}
//           onClick={() => window.open(item.redirectionLink, "_blank")}
//           >
//             <div
//               className="slider-image"
//               style={{
//                 backgroundImage: `url(${item?.BannerUrl})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//                 backgroundRepeat: "no-repeat",
//                 height: isMobile ? "250px" : "600px",
//                 width: "100%",
//               }}
//             />
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default FirstSection;
